import "cleave.js/dist/addons/cleave-phone.tz";
import React, { useCallback, useMemo, useState } from 'react'
import Cleave from 'cleave.js/react';
import MOBILE_NETWORKS, { matchNetwork } from 'gpesa';
import { findTariff } from 'gpesa/dist/tarriffs';
import debounce from 'lodash.debounce';
import { send } from '@emailjs/browser';
import { Analytics } from '@vercel/analytics/react';
import Loader from './Loader';
import NetworkSelector from "./NetworkSelector";
import PhoneInput from "./PhoneInput";

function formatAmount(value) {
  if (value === null) {
    return 'N/A';
  }
  return new Intl.NumberFormat("sw", { style: "currency", currency: "TZS", maximumFractionDigits: 1 }).format(
    value,
  )
}

const DOMAINS = [
  {
    name: 'mnos',
    title: 'Makato ya Simu',
  },
  {
    name: 'network',
    title: 'Tambua Mtandao',
  },
  {
    name: 'banks',
    title: 'Makato ya Benki',
    disabled: true,
  }
];

const App = () => {
  /**
   * @type {ReturnType<typeof useState<'mnos'|'network'|'banks'>>}
   */
  const [domain, setDomain] = useState('mnos');
  /**
   * @type {ReturnType<typeof useState<boolean>>}
   */
  const [isLoading, setIsLoading] = useState(false);
  /**
   * @type {ReturnType<typeof useState<string>>}
   */
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userContact, setUserContact] = useState('');
  const [network, setNetwork] = useState();
  /**
   * @type {ReturnType<typeof useState<'sendSame'|'sendOther'|'sendBank'|'withdraw'>>}
   */
  const [transactionType, setTransactionType] = useState('sendSame');
  /**
   * @type {ReturnType<typeof useState<string>>}
   */
  const [amount, setAmount] = useState('');

  /** @type {[string, string, string]} */
  const charges = useMemo(() => {
    if (amount === '') {
      return ['Ingiza kiasi'];
    }

    /** @type {{ fee: number, levy: number }} */
    const tarrif = findTariff?.(network?.mobile_money, amount)?.[transactionType];
    if (tarrif) {
      return [
        formatAmount(tarrif?.levy),
        formatAmount(tarrif?.fee),
        tarrif?.levy ? formatAmount(tarrif.levy + tarrif?.fee) : formatAmount(tarrif?.fee)
      ]
    }

    return ['Hakuna', 'Hakuna', 'Hakuna'];
  }, [amount, network?.mobile_money, transactionType]);

  const determineNetwork = useCallback((networkName) => {
    const config = MOBILE_NETWORKS.find(({ name }) => name === networkName);
    setNetwork(config);
  }, []);

  const clearState = useCallback(() => {
    setPhoneNumber('');
    setUserContact('');
    setIsLoading(false);
    setNetwork(undefined);
    setTransactionType('sendSame');
  }, []);
console.log(charges)
  return (
    <main>
      <h1 style={{ textAlign: 'center' }}>GPesa</h1>
      <section className="container">
        <div className="row">
          {DOMAINS.map(({ name, title, disabled }) => (
            <div key={name} className="column">
              <button
                className={`button block${domain !== name ? ' button-outline' : ''}`}
                onClick={() => {
                  setPhoneNumber('');
                  setDomain(name);
                }}
                disabled={disabled}
              >
                {title}{disabled ? ' (Coming Soon)' : ''}
              </button>
            </div>
          ))}
        </div>
        {domain === 'mnos' ? (
          <form>
            <label>Aina ya Muamala: <small style={{ fontWeight: 'normal' }}>(mf. Kutuma Pesa)</small>
              <select
                style={{ marginBottom: 15 }}
                value={transactionType}
                onChange={(e) => setTransactionType(e?.target?.value ?? '')}
              >
                <option value="" disabled>Chagua aina ya muamala</option>
                <option value="sendSame">Tuma Pesa (Mtandao Mmoja)</option>
                <option value="sendOther">Tuma Pesa (Mitandao Mingine)</option>
                <option value="sendBank">Tuma Pesa Kwenda Benki</option>
                <option value="withdraw">Toa Pesa</option>
                <option value="payBusiness">Lipa Kwa Simu</option>
              </select>
            </label>
            {transactionType === 'sendSame' || transactionType === 'sendOther' || transactionType === 'sendBank' || transactionType === 'payBusiness' ? (
              <NetworkSelector
                containerStyle={{ flex: 1 }}
                value={network?.name}
                onChange={(e) => determineNetwork(e?.target?.value ?? '')}
              />
            ) : null}
            {transactionType === 'withdraw' ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <NetworkSelector
                  containerStyle={{ flex: 1 }}
                  value={network?.name}
                  onChange={(e) => determineNetwork(e?.target?.value ?? '')}
                />
                <b style={{ marginBottom: '1.5rem' }}>AU</b>
                <PhoneInput
                  containerStyle={{ flex: 1 }}
                  onKeyDown={() => setIsLoading(true)}
                  onChange={debounce((value) => {
                    const config = matchNetwork(value);
                    setPhoneNumber(value);
                    setNetwork(config);
                    setIsLoading(false);
                  }, 500)}
                  clearState={clearState}
                />
              </div>
            ) : null}
            <label>Kiasi cha Pesa: <small style={{ fontWeight: 'normal' }}>(mf. 100)</small>
              <Cleave
                placeholder="Andika kiasi cha pesa hapa"
                options={{
                  numeral: true,
                  numeralThousandsGroupStyle: 'thousand'
                }}
                value={amount}
                style={{ marginBottom: 0 }}
                onChange={(event) => {
                  setAmount(event.target.rawValue)
                }}
                maxLength={10}
              />
            </label>
          </form>
        ) : null}
        {domain === 'network' ? (
          <form>
            <PhoneInput
              containerStyle={{ flex: 1 }}
              onKeyDown={() => setIsLoading(true)}
              onChange={debounce((value) => {
                const config = matchNetwork(value);
                setPhoneNumber(value);
                setNetwork(config);
                setIsLoading(false);
              }, 500)}
              clearState={clearState}
            />
          </form>
        ) : null}
      </section>
      {isLoading && (
        <div style={{ textAlign: 'center' }}><Loader /></div>
      )}
      {!isLoading && network ? (
        <section className="container">
          <pre>
            <code style={{ fontSize: 14 }}>
              Mtandao: <b>{network?.name}</b>
              {domain === 'mnos' ? (
                <>
                  <br />
                  Huduma ya Fedha: <b>{network?.mobile_money ?? 'Hakuna'}</b>
                  {amount ? (
                    <>
                      <br />
                      Makato ya Serikali: <b>{charges?.[0] ?? 'Hakuna'}</b>
                      <br />
                      Makato ya Mtandao: <b>{charges?.[1] ?? 'Hakuna'}</b>
                      <br />
                      Jumla ya Makato: <b>{charges?.[2] ?? 'Hakuna'}</b>
                    </>
                  ): (
                    <>
                      <br />
                      Ingiza kiasi
                    </>
                  )}
                </>
              ) : null}
            </code>
          </pre>
          <small>Je, unaamini jibu ya GPesa limekosewa? Tafadhali bonyeza 'Jibu Limekosewa' kutuma taarifa yako:</small>
          &ensp;
          <button
            className="button button-outline button-small"
            onClick={async () => {
              setIsLoading(true);
              await send('default_service', 'template_lxdbfjn', { phone: phoneNumber, user: 'wrong_answer' });
              alert('Asante kwa kutuma taarifa. GPesa hustawi kwajili yako.');
              clearState();
            }}
          >
            Jibu Limekosewa
          </button>
        </section>
      ) : null}
      {!isLoading && network === null ? (
        <section className="container" style={{ margin: 'auto' }}>
          <pre>
            <code>
              Samahani, GPesa haijaweza kutambua mtandao wa namba ulioingiza.
              <br />
              Kama una uhakika na namba uliyoingiza,
              tafadhali bonyeza 'Tafuta Zaidi' hapo chini ili GPesa iendelee kutafuta mtandao.
              <br />
              Ili kupata majibu yatakayopatikana, tafadhali tuachie namba yako ya simu au barua pepe.
            </code>
          </pre>
          <div className="row">
            <div className="column">
              <input
                type="text"
                placeholder="[si lazima] Namba ya simu au Barua pepe"
                onChange={(event) => setUserContact(event.target.value)}
              />
            </div>
            <div className="column">
              <button
                onClick={async () => {
                  setIsLoading(true);
                  await send('default_service', 'template_lxdbfjn', { phone: phoneNumber, user: userContact });
                  alert('Asante kwa kuwasiliana nasi. Tutakutumia majibu kwa njia ya barua pepe au simu.');
                  window.location.reload();
                }}
              >
                Tafuta Zaidi
              </button>
            </div>
          </div>
        </section>
      ) : null}
      <Analytics />
    </main>
  );
}

export default App
